import { render, staticRenderFns } from "./GridMatchController.vue?vue&type=template&id=0c07a4d2&scoped=true&"
import script from "./GridMatchController.vue?vue&type=script&lang=js&"
export * from "./GridMatchController.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c07a4d2",
  null
  
)

export default component.exports